// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-fd2304cc]{display:block;width:1em;height:1em;stroke-width:0;stroke:currentColor;fill:currentColor}", ""]);
// Exports
module.exports = exports;
